import { render, staticRenderFns } from "./FootprintCard.vue?vue&type=template&id=d85bea74"
import script from "./FootprintCard.vue?vue&type=script&lang=js"
export * from "./FootprintCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports